import apiClient, { unwrap } from './client';
import { historyStart } from '../utils/historyWindow';

export const expensesApi = {
  getAll: async (from = historyStart()) => {
    const res = await apiClient.get('/expenses', { params: { size: 1000, sort: 'date,desc', ...(from ? { from } : {}) } });
    const page = unwrap(res);
    return page?.content ?? page ?? [];
  },

  create: async (expense) => {
    const res = await apiClient.post('/expenses', expense);
    return unwrap(res);
  },

  update: async (id, expense) => {
    const res = await apiClient.put(`/expenses/${id}`, expense);
    return unwrap(res);
  },

  remove: async (id) => {
    await apiClient.delete(`/expenses/${id}`);
  },

  getComparison: async () => {
    const res = await apiClient.get('/expenses/comparison/month-over-month');
    return unwrap(res);
  },

  getHistory: async (from, to, periodType) => {
    const res = await apiClient.get('/expenses/history', {
      params: { from, to, periodType }
    });
    return unwrap(res);
  },
};
